import { BentoRow, BentoRowProps } from '../../components/Bento/Bento'
import { createWidget } from '../widget-utils'

interface BentoRowWidgetProps extends BentoRowProps {
  isLoading?: boolean
}

export const BentoRowWidget = ({
  isLoading,
  ...props
}: BentoRowWidgetProps) => <BentoRow {...props} />

export const BentoRowWidgetDefinition = createWidget(BentoRowWidget, {
  type: 'BentoRow',
})
